export const PrintMode = {
  Simplex: 100,
  Duplex: 200
}
